import {inject} from "vue";
import {usePage} from "@inertiajs/vue3";

const injectionKey = Symbol('can')

export const useCan = () => inject(injectionKey)

export default {
  install: (app, options) => {
    const can = (permission) => {
      const {user} = usePage().props;

      if (permission.includes('|')) {
        const permissions = permission.split('|');

        return permissions.some(perm => user.permissions[perm] || false);
      }

      return user.permissions[permission] || false;
    }

    app.provide(injectionKey, can)
    app.config.globalProperties.$can = can
  }
};
